import { API_VERSION } from 'src/utils/constants';

import { makeQueryString } from 'src/utils/helpers';
import HttpClient from './http';

export const getToursReq = (payload: any): Promise<any> => {
  return HttpClient.get({
    path: `${API_VERSION}/tours/?${makeQueryString(payload)}&sortByRate=true`,
    baseURL: process.env.REACT_APP_REMOTE as string,
  });
};
export const getTourByIdReq = (id: string): Promise<any> => {
  return HttpClient.get({ path: `${API_VERSION}/tours/${id}`, baseURL: process.env.REACT_APP_REMOTE as string });
};

export const getToursByName = (query: Record<string, any>): Promise<any> => {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => params.append(`${key}[]`, item));
    } else if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });

  const queryString = params.toString();

  return HttpClient.get({
    path: `${API_VERSION}/tours/search?${queryString}`,
    baseURL: process.env.REACT_APP_REMOTE as string,
  });
};

export type AgentWebMessage = {
  externalUserId: string;
  text: string;
  profileName: string;
};

export const sendAgentWebMessage = (payload: AgentWebMessage): Promise<any> => {
  return HttpClient.post(
    {
      path: `${API_VERSION}/agent/web/messages`,
      baseURL: (process.env.REACT_APP_AGENT_API_URL || process.env.REACT_APP_REMOTE) as string,
    },
    payload
  );
};

export const getAgentWebMessages = (externalUserId: string): Promise<any> => {
  return HttpClient.get({
    path: `${API_VERSION}/agent/web/conversations/${externalUserId}/messages`,
    baseURL: (process.env.REACT_APP_AGENT_API_URL || process.env.REACT_APP_REMOTE) as string,
  });
};

export const resetAgentWebConversation = (externalUserId: string): Promise<any> => {
  return HttpClient.post(
    {
      path: `${API_VERSION}/agent/web/conversations/${externalUserId}/reset`,
      baseURL: (process.env.REACT_APP_AGENT_API_URL || process.env.REACT_APP_REMOTE) as string,
    },
    {}
  );
};

export const extractToursFromAgentResponse = (data: any): any[] => {
  if (Array.isArray(data)) {
    return data;
  }

  const directTours = data?.tours || data?.suggestedTours || data?.recommendedTours || data?.data?.tours;

  if (Array.isArray(directTours)) {
    return directTours;
  }

  if (Array.isArray(data?.data)) {
    return data.data;
  }

  if (Array.isArray(data?.messages)) {
    return data.messages.flatMap((item: any) => {
      return item?.tours || item?.suggestedTours || item?.recommendedTours || [];
    });
  }

  return [];
};
